import { useConsentConfig } from 'components/ConsentConfigProvider'

import Locale from '../locale'

import makeLocaleKey from './makeLocaleKey'


export default function useBannerCopy() {
  const consentConfig = useConsentConfig()
  const localeKey = makeLocaleKey(consentConfig)

  return Locale[localeKey]
}

